import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

const SelectFilterHeaderCell = ({ value, options, setFilter }) => (
  <th style={{ marginRight: 15 }} className="react-select">
    <ReactSelect
      options={options || []}
      onChange={data => setFilter({ data })}
      value={value}
      isClearable
      styles={{
        control: base => ({
          ...base,
          height: 26,
          minHeight: 26,
        }),
        singleValue: provided => ({ ...provided, color: '#555555', fontSize: 10 }),
        placeholder: provided => ({ ...provided, color: '#a5a2a2', fontSize: 10 }),
        clearIndicator: provided => ({ ...provided, padding: 2, height: 26 }),
        indicatorsContainer: provided => ({ ...provided, padding: 2, height: 26 }),
        dropdownIndicator: provided => ({ ...provided, padding: 2, height: 26 }),
        valueContainer: provided => ({
          ...provided,
          height: 26,
          padding: '0 6px',
        }),
        option: (provided, state) => ({
          ...provided,
          color: state.isSelected ? '#fff' : 'grey',
          padding: '4px 10px',
          fontSize: 12,
        }),
      }}
    />
  </th>
);

SelectFilterHeaderCell.propTypes = {
  setFilter: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.object,
};

SelectFilterHeaderCell.defaultProps = {
  setFilter: () => {},
  options: [],
  value: null,
};

export default SelectFilterHeaderCell;



// WEBPACK FOOTER //
// ./src/components/Tables/SelectFilterHeaderCell.js